export const locale = {
    lang: 'en',
    data: {
        TRANSFORM_LIST: 'Turn cards into lists',
        SELECTION: 'Selection',
        ACTIVITY: 'Activity',
    }
};
